module.exports = "<select name=\"country\" class=\"form-control form-accede\" ng-init=\"$ctrl.initial\" ng-model=\"$ctrl.selected\" ng-change=\"$ctrl.onSelect({country: $ctrl.selected})\"\n        ng-disabled=\"$ctrl.disabled\">\n  <option value=\"\" disabled>Seleccione un País</option>\n  <option ng-repeat=\"country in $ctrl.countries\" value=\"{{ country.code }}\">\n    {{ country.name }}\n  </option>\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/countries/countries.html
// module id = 480
// module chunks = 0